/** Shared layout constants for the agent portal */
export const AGENT_MOBILE_BREAKPOINT_PX = 992;

/** Horizontal scroll for wide agent tables on small screens */
export const AGENT_TABLE_SCROLL_X = 1100;
